import { Skeleton } from '@/shared/ui/Skeleton';
import skeletonStyles from './FAQSkeleton.module.css';

export function FAQSkeleton() {
  return (
    <div className={skeletonStyles.container} data-testid="faq-skeleton">
      {/* Header: title + description + button */}
      <div className={skeletonStyles.header}>
        <div className={skeletonStyles.headerText}>
          <Skeleton width={320} height={36} />
          <Skeleton width={440} height={20} />
        </div>
        <Skeleton width={160} height={40} borderRadius="var(--radius-md)" />
      </div>

      {/* Segmented toggle */}
      <div className={skeletonStyles.tabs}>
        <Skeleton width={240} height={40} borderRadius="var(--radius-md)" />
      </div>

      {/* Accordion items */}
      <div className={skeletonStyles.accordionList}>
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div key={i} className={skeletonStyles.accordionItem}>
            <Skeleton width={`${55 + i * 5}%`} height={22} />
          </div>
        ))}
      </div>
    </div>
  );
}
